import produce from "immer";

import type {ListDataState, Reducer} from "../common";
import {DATA_INITIAL, DATA_LOADED, DATA_LOADING} from "../common";
import {listToLookupTable} from "amn/model/common/Divers";
import type {CreateSubscriptionResponse, Subscription} from "amn/model/account/Subscription";
import {
  COMPLETE_ACCOUNT_SUBSCRIPTION_CHECKOUT_SUCCESS,
  CREATE_ACCOUNT_SUBSCRIPTION_SUCCESS,
  LOAD_ACCOUNT_SUBSCRIPTION_SUCCESS,
  LOAD_ACCOUNT_SUBSCRIPTIONS_REQUEST,
  LOAD_ACCOUNT_SUBSCRIPTIONS_SUCCESS
} from "../../actions/account/account-subscriptions.actions";
import {ActionPromisePayload} from "../../actions/common";

export type AccountSubscriptionsState = ListDataState<Subscription>

const INITIAL_STATE: AccountSubscriptionsState = {
  entities: {},
  status: DATA_INITIAL,
}


const accountSubscriptions: Reducer = produce((draft: AccountSubscriptionsState, action) => {
  switch (action.type) {

    case LOAD_ACCOUNT_SUBSCRIPTION_SUCCESS: {
      if (action.success) {
        const entity = action.success;
        draft.entities[entity.id] = {
          ...entity
        };
      }
      break;
    }

    ///******************************
    //

    case CREATE_ACCOUNT_SUBSCRIPTION_SUCCESS:
    case COMPLETE_ACCOUNT_SUBSCRIPTION_CHECKOUT_SUCCESS: {
      const payload: ActionPromisePayload<{}, CreateSubscriptionResponse> = action;
      if (payload.success?.subscription) {
        draft.entities[payload.success?.subscription.id] = payload.success?.subscription;
        draft.status = DATA_LOADED;
      }
      break;
    }

    ///******************************
    //

    case LOAD_ACCOUNT_SUBSCRIPTIONS_REQUEST: {
      draft.entities = {};
      draft.status = DATA_LOADING;
      break;
    }

    case LOAD_ACCOUNT_SUBSCRIPTIONS_SUCCESS: {
      if (action.success) {
        draft.entities = listToLookupTable(action.success.items);
        draft.status = DATA_LOADED;
      }
      break;
    }


    default:
      break;
  }
}, INITIAL_STATE);


export default accountSubscriptions;
